// Weekly lesson-day helpers (0 = Monday ... 6 = Sunday)
export const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
export const DAYS_SHORT = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const todayIndex = () => (new Date().getDay() + 6) % 7; // Mon=0

// Returns { label, daysUntil, isToday, doneToday }
export const lessonDayStatus = (lessonDay, activity = []) => {
  if (lessonDay === null || lessonDay === undefined) return null;
  const today = todayIndex();
  const daysUntil = (lessonDay - today + 7) % 7;
  const d = new Date();
  const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const doneToday = activity.includes(key);
  let label;
  if (daysUntil === 0) label = doneToday ? "Lesson day - done!" : "Lesson day is today!";
  else if (daysUntil === 1) label = "Lesson day is tomorrow";
  else label = `Lesson day in ${daysUntil} days`;
  return { label, daysUntil, isToday: daysUntil === 0, doneToday, dayName: DAYS[lessonDay] };
};
